import { render, staticRenderFns } from "./ProduceForm.vue?vue&type=template&id=6c83f88e&scoped=true&"
import script from "./ProduceForm.vue?vue&type=script&lang=js&"
export * from "./ProduceForm.vue?vue&type=script&lang=js&"
import style0 from "./ProduceForm.vue?vue&type=style&index=0&id=6c83f88e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c83f88e",
  null
  
)

export default component.exports